import React, { Component } from 'react';
import {Subtopic, TextHolder, Footer, Button} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';




export class ChapterTwentyThree extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">


        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {"" }
        </Subtopic>

        <TextHolder text="By mid 2018, SEA was home to eight unicorns split evenly between Singapore and Indonesia. Compared to other Asian regions, SEA did well in this unicorn list. According to Crunchbase, there are only three unicorns in South Korea and one each in Japan, Australia and Hong Kong. India has about 10 unicorns, and of course China completely dominated the unicorn list with about 90." />
        <TextHolder text="SEA’s unicorns thrive on radical ideas. While Uber’s on-demand car service app was the rage, Go-Jek went against this trend to become a “super app.” Anyone can use it to get on-demand services ranging from hairdressing and home cleaning to food delivery and of course, ride-sharing. Razer entered as a commodity computer accessory business, but ultimately succeeded by sharply focusing on a niche sector: computer mice and keyboards for gamers." />
        <TextHolder text="Founder Tan Min-Liang has endowed Razer with a cult-like culture in which fans sculpted the company’s logo into their hair styles." />
        <TextHolder text="Each SEA unicorn has a unique story, but all feature hard-charging founders, most of whom studied overseas. No different than their counterparts in the U.S. and elsewhere, these founders were steadfast in their vision and convinced VCs to fund their expansion and development. " />

        <div className="block-outer block-outer-tableholder">
          <div className="block-inner block-inner-tableholder">
            <table id="t01">
            <tbody>
              <tr>
                <th>Company</th>
                <th>Home country</th>
                <th>Valuation/market cap</th>
              </tr>
              <tr>
                <td>Bukalapak</td>
                <td>Indonesia</td>
                <td>"Over $1 billion" as of <a href="http://www.thejakartapost.com/life/2018/01/11/bukalapak-officially-becomes-indonesias-fourth-unicorn-startup.html">January 2018</a></td>
              </tr>
              <tr>
                <td>Gojek</td>
                <td>Indonesia</td>
                <td>$5 billion</td>
              </tr>
              <tr>
                <td>Grab</td>
                <td>Singapore</td>
                <td>$10 billion</td>
              </tr>
              <tr>
                <td>Lazada</td>
                <td>Singapore</td>
                <td>$3.15 billion</td>
              </tr>
              <tr>
                <td>Razer</td>
                <td>Singapore</td>
                <td>$1.98 billion (as of August 2018)</td>
              </tr>
              <tr>
                <td>Sea</td>
                <td>Singapore</td>
                <td>$4.90 billion (<a href="https://finance.yahoo.com/quote/se?ltr=1&guccounter=1">post-IPO</a> August 2018)</td>
              </tr>
              <tr>
                <td>Tokopedia</td>
                <td>Indonesia</td>
                <td>Undisclosed, funding of $1.3 billion in <a href="https://www.crunchbase.com/organization/tokopedia">August 2018 values it past US$1 billion</a></td>
              </tr>
              <tr>
                <td>Traveloka</td>
                <td>Indonesia</td>
                <td>$2 billion</td>
              </tr>
              </tbody>
            </table>
            <div className="highcharts-notes">

              <p> Sources: Bloomberg, TechCrunch, Yahoo! Finance, <a href="https://www.crunchbase.com">Crunchbase</a></p>
              <p> Notes: Valuation is as of June 2018 or as stated otherwise</p>
            </div>
        </div>
      </div>




          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/23.js